import React, { Component, Fragment } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import Main from '../Main/Main';
import MarketSwitcher from '../MarketSwitcher';
import ResourceCard from './ResourceCard';
import axiosUI from '../../axiosUI';
import { withGlobalContext } from '../../App';
import { RESOURCE_STATES } from '../../constants';
import './homepage.scss';
const { DRAFT } = RESOURCE_STATES;

class Homepage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      articlesLoading: false,
      articleHasDrafts: false,
      bannersLoading: false,
      bannerHasDrafts: false,
      translationsLoading: false,
      translationHasDrafts: false,
      channelsLoading: false,
      channelHasDrafts: false,
      openingHoursLoading: false,
      openingHourHasDrafts: false,
    };
  }

  componentDidMount() {
    this.refreshAllCards();
  }

  refreshAllCards = () => {
    this.checkArticleDrafts();
    this.checkTranslationDrafts();
    this.checkBannerDrafts();
    this.checkChannelDrafts();
    this.checkOpeningHourDrafts();
  };

  checkArticleDrafts = () => {
    const { savedCountry, savedLanguage } = this.props;
    if (savedCountry && savedLanguage) {
      this.setState({ articlesLoading: true }, async () => {
        const url = `/api/articles`;
        let articleHasDrafts = false;

        try {
          const { data: articles } = await axiosUI.get(url, {
            params: {
              salesChannel: savedCountry,
              locale: savedLanguage,
              loadFull: false,
            },
          });

          articleHasDrafts = articles.some(article => {
            return article.totalDrafts > 0;
          });
        } catch (error) {
          console.log(error);
        }

        this.setState({ articlesLoading: false, articleHasDrafts });
      });
    }
  };

  checkTranslationDrafts = () => {
    const { savedCountry, savedLanguage } = this.props;
    if (savedCountry && savedLanguage) {
      this.setState({ translationsLoading: true }, async () => {
        const url = `/api/translations`;
        let translationHasDrafts = false;

        try {
          const { data: translations } = await axiosUI.get(url, {
            params: {
              salesChannel: savedCountry,
              locale: savedLanguage,
            },
          });

          translationHasDrafts = translations.some(translation => {
            return translation.state === DRAFT;
          });
        } catch (error) {
          console.log(error);
        }

        this.setState({ translationsLoading: false, translationHasDrafts });
      });
    }
  };

  checkBannerDrafts = () => {
    const { savedCountry, savedLanguage } = this.props;
    if (savedCountry && savedLanguage) {
      this.setState({ bannersLoading: true }, async () => {
        const url = `/api/banners`;
        let bannerHasDrafts = false;

        try {
          const { data: banners } = await axiosUI.get(url, {
            params: {
              salesChannel: savedCountry,
              locale: savedLanguage,
            },
          });

          bannerHasDrafts = banners.some(banner => {
            return banner.state === DRAFT;
          });
        } catch (error) {
          console.log(error);
        }

        this.setState({
          bannersLoading: false,
          bannerHasDrafts,
        });
      });
    }
  };

  checkChannelDrafts = () => {
    const { savedCountry, savedLanguage } = this.props;
    if (savedCountry && savedLanguage) {
      this.setState({ channelsLoading: true }, async () => {
        const url = `/api/channels`;
        let channelHasDrafts = false;

        try {
          const { data: channels } = await axiosUI.get(url, {
            params: {
              salesChannel: savedCountry,
              locale: savedLanguage,
            },
          });

          channelHasDrafts = channels.some(channel => {
            return channel.state === DRAFT;
          });
        } catch (error) {
          console.log(error);
        }

        this.setState({
          channelsLoading: false,
          channelHasDrafts,
        });
      });
    }
  };

  checkOpeningHourDrafts = () => {
    const { savedCountry, savedLanguage } = this.props;
    if (savedCountry && savedLanguage) {
      this.setState({ openingHoursLoading: true }, async () => {
        const url = `/api/opening-hours`;
        let openingHourHasDrafts = false;

        try {
          const { data } = await axiosUI.get(url, {
            params: {
              salesChannel: savedCountry,
              locale: savedLanguage,
            },
          });

          openingHourHasDrafts = data.hasDrafts;
        } catch (error) {
          console.log(error);
        }

        this.setState({
          openingHoursLoading: false,
          openingHourHasDrafts,
        });
      });
    }
  };

  render() {
    return (
      <Fragment>
        <Sidebar />
        <Topbar className="flex items-center">
          <span className="font-bold text-lg mr-8">Market</span>
          <MarketSwitcher
            {...this.props}
            country={this.props.savedCountry}
            language={this.props.savedLanguage}
            onMarketUpdate={this.refreshAllCards}
          />
        </Topbar>
        <Main className="homepage__main">
          <div className="flex items-center justify-center">
            <div className="clippy_wrapper">
              <div className="clippy">
                <div className="eye left"></div>
                <div className="eye right"></div>
              </div>
            </div>
            <div className="text-3xl font-black text-center ml-20">
              Welcome to Clippy!
            </div>
          </div>
          <div className="mt-8">
            <div className="flex">
              <ResourceCard
                name="Articles"
                loading={this.state.articlesLoading}
                hasDrafts={this.state.articleHasDrafts}
                draftDestination={`articles/${this.props.savedCountry}/${this.props.savedLanguage}?show_drafts_only=true`}
                refreshStatus={this.checkArticleDrafts}
              />
              <ResourceCard
                name="Translations"
                loading={this.state.translationsLoading}
                hasDrafts={this.state.translationHasDrafts}
                draftDestination={`translations/${this.props.savedCountry}/${this.props.savedLanguage}/changeset`}
                refreshStatus={this.checkTranslationDrafts}
              />
            </div>
            <div className="flex">
              <ResourceCard
                name="Banners"
                loading={this.state.bannersLoading}
                hasDrafts={this.state.bannerHasDrafts}
                draftDestination={`banners/${this.props.savedCountry}/${this.props.savedLanguage}/changeset`}
                refreshStatus={this.checkBannerDrafts}
              />
              <ResourceCard
                name="Channels"
                loading={this.state.channelsLoading}
                hasDrafts={this.state.channelHasDrafts}
                draftDestination={`channeling/${this.props.savedCountry}/${this.props.savedLanguage}/changeset`}
                refreshStatus={this.checkChannelDrafts}
              />
            </div>
            <div className="flex">
              <ResourceCard
                name="Opening hours"
                loading={this.state.openingHoursLoading}
                hasDrafts={this.state.openingHourHasDrafts}
                draftDestination={`channeling/${this.props.savedCountry}/${this.props.savedLanguage}/opening-hours/changeset`}
                refreshStatus={this.checkOpeningHourDrafts}
              />
              <div className="w-1/2 m-8"></div>
            </div>
          </div>
        </Main>
      </Fragment>
    );
  }
}

export default  withGlobalContext(Homepage);
